export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13019.cf10b934.jpg";